import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import './App.css';

// Sayfalar
import NotFound from './pages/NotFound';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import Dashboard from './pages/Dashboard';
import ProductsPage from './pages/ProductsPage';
import ServicesPage from './pages/ServicesPage';
import FaqPage from './pages/FaqPage';

// Bileşenler
import Header from './components/Header';
import Footer from './components/Footer';

// Servisler
import './services/axios.interceptor';

function App() {
  return (
    <HelmetProvider>
      <div className="app">
        <Helmet defaultTitle="Üstün Bilgisayar | İstanbul'un En İyi Bilgisayar Tamiri ve Teknik Servis Merkezi" titleTemplate="%s | Üstün Bilgisayar">
          <meta name="description" content="✅ Üstün Bilgisayar ✅ 25 yıllık tecrübe ile İstanbul Ümraniye'de bilgisayar tamiri, teknik servis, laptop ve masaüstü onarım hizmetleri. Aynı gün hızlı çözüm! ☎ 0532 610 95 11" />
          <meta name="keywords" content="bilgisayar tamiri, laptop tamiri, teknoloji servisi, teknik destek, ümraniye bilgisayar tamiri, mouse tamir, pc bakım, Üstün Bilgisayar, ümraniye tamirci, Üstün Bilişim" />
          <meta name="author" content="Üstün Bilgisayar" />
          <meta name="robots" content="index, follow" />
          <meta name="revisit-after" content="1 days" />
          <meta name="language" content="Turkish" />
          <meta name="geo.region" content="TR-34" />
          <meta name="geo.placename" content="Ümraniye, İstanbul" />
          <link rel="canonical" href="https://ustunbilisim.com" />
          <meta property="og:title" content="Üstün Bilgisayar | 25 Yıllık Tecrübe ile Bilgisayar Tamiri" />
          <meta property="og:description" content="Ümraniye'nin en güvenilir bilgisayar tamircisi Üstün Bilgisayar'da aynı gün onarım garantisi ve uygun fiyatlarla hizmet alın!" />
          <meta property="og:url" content="https://ustunbilisim.com" />
          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Üstün Bilgisayar" />
          <meta property="og:image" content="https://ustunbilisim.com/logo.png" />
          <meta property="og:locale" content="tr_TR" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Üstün Bilgisayar | İstanbul'da Profesyonel Bilgisayar Tamiri" />
          <meta name="twitter:description" content="Laptop, masaüstü tamiri ve teknik destek için Üstün Bilgisayar yanınızda! 25 yıllık tecrübe, aynı gün çözüm!" />
        </Helmet>
        
        <Header />
        
        <main className="main-content">
          <Routes>
            {/* Genel Yollar */}
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/sss" element={<FaqPage />} />
            
            {/* 404 Sayfası */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
